"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIndexThreshold = exports.setCurrentStream = exports.SET_INDEX_THRESHOLD = exports.SET_CURRENT_MESSAGE_STREAM = void 0;
var SET_CURRENT_MESSAGE_STREAM = 'SET_CURRENT_MESSAGE_STREAM';
exports.SET_CURRENT_MESSAGE_STREAM = SET_CURRENT_MESSAGE_STREAM;
var SET_INDEX_THRESHOLD = 'SET_INDEX_THRESHOLD';
exports.SET_INDEX_THRESHOLD = SET_INDEX_THRESHOLD;

var setCurrentStream = function setCurrentStream(id) {
  return {
    type: SET_CURRENT_MESSAGE_STREAM,
    payload: id
  };
};

exports.setCurrentStream = setCurrentStream;

var setIndexThreshold = function setIndexThreshold(threshold) {
  return {
    type: SET_INDEX_THRESHOLD,
    payload: threshold
  };
};

exports.setIndexThreshold = setIndexThreshold;